import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, createBlock as _createBlock, vModelRadio as _vModelRadio, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9b4a1b94"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "AdminClubs" }
const _hoisted_2 = { id: "showclubs" }
const _hoisted_3 = { class: "display-2 adminHeadline" }
const _hoisted_4 = { class: "tabHeight" }
const _hoisted_5 = { class: "row align--center justify--space-between" }
const _hoisted_6 = { class: "md1 flex ml-4" }
const _hoisted_7 = {
  class: "md3 flex",
  style: {"display":"flex"}
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Søg")
const _hoisted_9 = { class: "md2 flex" }
const _hoisted_10 = { class: "md2 flex" }
const _hoisted_11 = { class: "md2 flex mr-4" }
const _hoisted_12 = { class: "row justify--center mb-4" }
const _hoisted_13 = { class: "flex" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-4 sliderLabel center" }, [
  /*#__PURE__*/_createTextVNode("Inkluder kun klubber der har medlemmer"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" i alderen mellem:")
], -1))
const _hoisted_15 = { class: "row justify--center mb-4" }
const _hoisted_16 = { class: "flex" }
const _hoisted_17 = { class: "row justify--center mb-4" }
const _hoisted_18 = { class: "flex" }
const _hoisted_19 = { class: "row justify--center mb-4" }
const _hoisted_20 = { class: "flex" }
const _hoisted_21 = { class: "row justify--center mb-4" }
const _hoisted_22 = { class: "flex" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Eksporter")
const _hoisted_24 = { class: "flex" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Giv rettigheder")
const _hoisted_26 = { class: "row align--center justify--start mt-4" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex md1 ml-4" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Kolonner:")
], -1))
const _hoisted_28 = {
  class: "flex md10",
  style: {"display":"flex"}
}
const _hoisted_29 = { key: 0 }
const _hoisted_30 = {
  key: 1,
  class: "va-table-responsive"
}
const _hoisted_31 = {
  class: "va-table va-table--striped clubsTable",
  style: {"width":"100%"}
}
const _hoisted_32 = { class: "center" }
const _hoisted_33 = { class: "center" }
const _hoisted_34 = { class: "center" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Handlinger", -1))
const _hoisted_36 = ["id"]
const _hoisted_37 = ["id"]
const _hoisted_38 = ["id"]
const _hoisted_39 = ["id"]
const _hoisted_40 = ["id"]
const _hoisted_41 = ["id"]
const _hoisted_42 = ["id"]
const _hoisted_43 = ["id"]
const _hoisted_44 = ["href"]
const _hoisted_45 = ["id"]
const _hoisted_46 = ["href"]
const _hoisted_47 = ["id"]
const _hoisted_48 = ["id"]
const _hoisted_49 = /*#__PURE__*/_createTextVNode("Åbningstider")
const _hoisted_50 = ["id"]
const _hoisted_51 = /*#__PURE__*/_createTextVNode("Medlemmer")
const _hoisted_52 = ["id"]
const _hoisted_53 = /*#__PURE__*/_createTextVNode("Hold")
const _hoisted_54 = ["id"]
const _hoisted_55 = ["id"]
const _hoisted_56 = ["href"]
const _hoisted_57 = ["id"]
const _hoisted_58 = ["id"]
const _hoisted_59 = ["href"]
const _hoisted_60 = ["id"]
const _hoisted_61 = /*#__PURE__*/_createTextVNode("Vis/Rediger")
const _hoisted_62 = /*#__PURE__*/_createTextVNode("Slet")
const _hoisted_63 = { class: "row justify--center align--baseline paginationControls" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mr-2" }, "Side:", -1))
const _hoisted_65 = {
  key: 0,
  class: "mr-2"
}
const _hoisted_66 = {
  key: 1,
  class: "mr-2"
}
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mr-2" }, "Antal rækker per side:", -1))
const _hoisted_68 = { class: "selectPageSize" }
const _hoisted_69 = /*#__PURE__*/_createTextVNode("Exporter")
const _hoisted_70 = { class: "layout gutter--xl" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row justify--center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "readingSize" }, [
      /*#__PURE__*/_createElementVNode("strong", null, "Tilføj nye åbningstider")
    ])
  ])
], -1))
const _hoisted_72 = { class: "row align--center" }
const _hoisted_73 = { class: "flex md10" }
const _hoisted_74 = { class: "row align--center" }
const _hoisted_75 = { class: "flex md6" }
const _hoisted_76 = { class: "flex md3" }
const _hoisted_77 = { class: "flex md3" }
const _hoisted_78 = { class: "row align--center" }
const _hoisted_79 = { class: "flex md12" }
const _hoisted_80 = { class: "flex md2" }
const _hoisted_81 = /*#__PURE__*/_createTextVNode("Tilføj")
const _hoisted_82 = { class: "layout gutter--xl" }
const _hoisted_83 = { class: "justify--center row" }
const _hoisted_84 = { class: "flex" }
const _hoisted_85 = { class: "display-6" }
const _hoisted_86 = { class: "layout gutter-xl" }
const _hoisted_87 = { class: "row align--center mb-2" }
const _hoisted_88 = { class: "flex md6" }
const _hoisted_89 = { class: "flex md3" }
const _hoisted_90 = { class: "flex md3" }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex md2" }, null, -1))
const _hoisted_92 = { class: "row align--center mb-2" }
const _hoisted_93 = { class: "flex md12" }
const _hoisted_94 = { class: "row justify--center" }
const _hoisted_95 = { class: "flex" }
const _hoisted_96 = /*#__PURE__*/_createTextVNode("Gem")
const _hoisted_97 = /*#__PURE__*/_createTextVNode("Slet")
const _hoisted_98 = { class: "row justify--center" }
const _hoisted_99 = { class: "flex" }
const _hoisted_100 = /*#__PURE__*/_createTextVNode("Luk")
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "layout gutter--xl" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "flex" }, [
      /*#__PURE__*/_createElementVNode("p", { class: "readingSize" }, "Er du sikker på at du vil slette åbningstiden?")
    ])
  ])
], -1))
const _hoisted_102 = /*#__PURE__*/_createTextVNode("Ja")
const _hoisted_103 = /*#__PURE__*/_createTextVNode("Nej")
const _hoisted_104 = { class: "layout gutter--xl" }
const _hoisted_105 = { class: "row" }
const _hoisted_106 = { class: "flex" }
const _hoisted_107 = { class: "readingSize" }
const _hoisted_108 = /*#__PURE__*/_createTextVNode("Er du sikker at du vil slette ")
const _hoisted_109 = /*#__PURE__*/_createTextVNode("?")
const _hoisted_110 = /*#__PURE__*/_createTextVNode("Ja")
const _hoisted_111 = /*#__PURE__*/_createTextVNode("Nej")
const _hoisted_112 = { class: "editclubmodal" }
const _hoisted_113 = { class: "layout gutter--xl" }
const _hoisted_114 = { class: "row align--center" }
const _hoisted_115 = { class: "flex md8" }
const _hoisted_116 = { class: "display-6 center" }
const _hoisted_117 = { class: "flex md4" }
const _hoisted_118 = ["src"]
const _hoisted_119 = /*#__PURE__*/_createTextVNode("Kluboplysninger")
const _hoisted_120 = { class: "row" }
const _hoisted_121 = { class: "md6 flex" }
const _hoisted_122 = { class: "flex md3" }
const _hoisted_123 = /*#__PURE__*/_createTextVNode("Ændre klublogo")
const _hoisted_124 = { class: "flex md3" }
const _hoisted_125 = { class: "flex md6" }
const _hoisted_126 = { class: "flex md3" }
const _hoisted_127 = { class: "flex md3" }
const _hoisted_128 = { class: "flex md6" }
const _hoisted_129 = { class: "flex md6" }
const _hoisted_130 = { class: "flex md6" }
const _hoisted_131 = { class: "flex md6" }
const _hoisted_132 = {
  class: "flex md12",
  id: "quillAdmClubDescription",
  style: {"padding-bottom":"64px"}
}
const _hoisted_133 = { class: "flex md6" }
const _hoisted_134 = { class: "flex md6 center" }
const _hoisted_135 = { class: "flex md4 center" }
const _hoisted_136 = { class: "flex md4 center" }
const _hoisted_137 = { class: "flex md4 center" }
const _hoisted_138 = { class: "flex md3 center" }
const _hoisted_139 = { class: "flex md3" }
const _hoisted_140 = /*#__PURE__*/_createTextVNode("Forny Kontigent")
const _hoisted_141 = { class: "flex md3 center" }
const _hoisted_142 = { class: "flex md3" }
const _hoisted_143 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "center" }, "Felter markeret med * kan ikke ændres", -1))
const _hoisted_144 = /*#__PURE__*/_createTextVNode("Opdater klub")
const _hoisted_145 = /*#__PURE__*/_createTextVNode("Annuller")
const _hoisted_146 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "display-6 center" }, "Vælg nyt klublogo", -1))
const _hoisted_147 = { class: "layout gutter--md" }
const _hoisted_148 = { class: "row align--baseline justify--center mb-2" }
const _hoisted_149 = { class: "flex md2" }
const _hoisted_150 = {
  class: "flex md6",
  style: {"display":"flex"}
}
const _hoisted_151 = /*#__PURE__*/_createTextVNode("Billedesøgning")
const _hoisted_152 = { class: "flex md2" }
const _hoisted_153 = { class: "row justify--center" }
const _hoisted_154 = { class: "flex md2 center" }
const _hoisted_155 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Valgt logo", -1))
const _hoisted_156 = ["src"]
const _hoisted_157 = { class: "imageFlexBox" }
const _hoisted_158 = { class: "center imageTitle" }
const _hoisted_159 = { class: "imageBox" }
const _hoisted_160 = ["value", "onClick"]
const _hoisted_161 = ["src", "title"]
const _hoisted_162 = { class: "row justify--center align--baseline paginationControls" }
const _hoisted_163 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mr-2" }, "Side:", -1))
const _hoisted_164 = {
  key: 0,
  class: "mr-2"
}
const _hoisted_165 = {
  key: 1,
  class: "mr-2"
}
const _hoisted_166 = { class: "row justify--center" }
const _hoisted_167 = { class: "flex" }
const _hoisted_168 = /*#__PURE__*/_createTextVNode("Gør billede til klublogo")
const _hoisted_169 = /*#__PURE__*/_createTextVNode("Annuller")
const _hoisted_170 = { class: "editclubsaldomodal" }
const _hoisted_171 = { class: "md12 flex" }
const _hoisted_172 = {
  class: "mb-4",
  style: {"font-size":"1.2em"}
}
const _hoisted_173 = { class: "row justify--center" }
const _hoisted_174 = {
  class: "md6 flex",
  style: {"font-size":"1.2em!important"}
}
const _hoisted_175 = /*#__PURE__*/_createTextVNode("Opdater Saldo")
const _hoisted_176 = /*#__PURE__*/_createTextVNode("Annuller")
const _hoisted_177 = { style: {"display":"block"} }
const _hoisted_178 = { style: {"float":"left"} }
const _hoisted_179 = { class: "display-6" }
const _hoisted_180 = /*#__PURE__*/_createTextVNode(" Hold ")
const _hoisted_181 = { style: {"margin":"24px"} }
const _hoisted_182 = { style: {"float":"right"} }
const _hoisted_183 = ["src"]
const _hoisted_184 = { key: 0 }
const _hoisted_185 = { style: {"display":"block","font-size":"18px","font-weight":"500","color":"#2f2f7f","margin":"4px"} }
const _hoisted_186 = { style: {"display":"block"} }
const _hoisted_187 = { style: {"float":"left"} }
const _hoisted_188 = { style: {"float":"right","margin-right":"4px"} }
const _hoisted_189 = {
  class: "va-table editclubteams-drawer-table",
  style: {"width":"100%"}
}
const _hoisted_190 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "editclubteams-drawer-table-head",
  hidden: ""
}, "Id", -1))
const _hoisted_191 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "editclubteams-drawer-table-head" }, "Turneringskategori", -1))
const _hoisted_192 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "editclubteams-drawer-table-head" }, "Allerede tilmeldte hold", -1))
const _hoisted_193 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "editclubteams-drawer-table-head" }, "Pris", -1))
const _hoisted_194 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "editclubteams-drawer-table-head" }, "Antal nye hold", -1))
const _hoisted_195 = {
  key: 0,
  class: "editclubteams-drawer-table-head"
}
const _hoisted_196 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "editclubteams-drawer-table-head" }, null, -1))
const _hoisted_197 = ["id"]
const _hoisted_198 = ["id"]
const _hoisted_199 = ["id"]
const _hoisted_200 = ["id"]
const _hoisted_201 = ["id"]
const _hoisted_202 = ["id"]
const _hoisted_203 = ["id"]
const _hoisted_204 = ["id"]
const _hoisted_205 = ["id"]
const _hoisted_206 = /*#__PURE__*/_createTextVNode("Bestil")
const _hoisted_207 = /*#__PURE__*/_createTextVNode("Luk")
const _hoisted_208 = { class: "row justify--center mt-4 mb-4" }
const _hoisted_209 = { class: "flex" }
const _hoisted_210 = { class: "display-6" }
const _hoisted_211 = { class: "row justify--center mb-4" }
const _hoisted_212 = { class: "md2 flex" }
const _hoisted_213 = {
  class: "md8 flex",
  style: {"display":"flex"}
}
const _hoisted_214 = /*#__PURE__*/_createTextVNode("Søg")
const _hoisted_215 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row justify--start center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex md6" }, [
    /*#__PURE__*/_createElementVNode("p", null, "Navn")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "flex md4" }, [
    /*#__PURE__*/_createElementVNode("p", null, "Klub")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "flex md2" }, [
    /*#__PURE__*/_createElementVNode("p", null, "Yderlige information")
  ])
], -1))
const _hoisted_216 = { class: "row justify--start align--center mb-4" }
const _hoisted_217 = {
  class: "flex md6 align-self--center",
  style: {"display":"flex"}
}
const _hoisted_218 = {
  key: 0,
  class: "flex md4 center"
}
const _hoisted_219 = {
  key: 1,
  class: "flex md4 center"
}
const _hoisted_220 = { class: "flex md2 center" }
const _hoisted_221 = { class: "row justify--center mb-4" }
const _hoisted_222 = { class: "flex" }
const _hoisted_223 = /*#__PURE__*/_createTextVNode("Tilføj")
const _hoisted_224 = /*#__PURE__*/_createTextVNode("Fjern")
const _hoisted_225 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "display-6 mb-2 center" }, "Medlemsinfo", -1))
const _hoisted_226 = { class: "memberinfocontainer" }
const _hoisted_227 = { class: "memberinfoitem" }
const _hoisted_228 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Navn:", -1))
const _hoisted_229 = { class: "memberinfoitem" }
const _hoisted_230 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Licens:", -1))
const _hoisted_231 = { class: "licenschip" }
const _hoisted_232 = { class: "memberinfoitem" }
const _hoisted_233 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Paradart:", -1))
const _hoisted_234 = { class: "memberinfoitem" }
const _hoisted_235 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Køn:", -1))
const _hoisted_236 = { class: "memberinfoitem" }
const _hoisted_237 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Fødselsdag:", -1))
const _hoisted_238 = { class: "memberinfoitem" }
const _hoisted_239 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Medlem siden: ", -1))
const _hoisted_240 = { class: "memberinfoitem" }
const _hoisted_241 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Adresse:", -1))
const _hoisted_242 = { class: "memberinfoitem" }
const _hoisted_243 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "By:", -1))
const _hoisted_244 = { class: "memberinfoitem" }
const _hoisted_245 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Telefon:", -1))
const _hoisted_246 = { class: "memberinfoitem" }
const _hoisted_247 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Email:", -1))
const _hoisted_248 = { class: "memberinfoitem" }
const _hoisted_249 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Klubrolle:", -1))
const _hoisted_250 = { class: "memberinfoitem" }
const _hoisted_251 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Karantæne:", -1))
const _hoisted_252 = {
  key: 0,
  class: "memberinfoitem"
}
const _hoisted_253 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Periode:", -1))
const _hoisted_254 = /*#__PURE__*/_createTextVNode("Ok")
const _hoisted_255 = { class: "tabHeight" }
const _hoisted_256 = { id: "newclubs" }
const _hoisted_257 = { key: 0 }
const _hoisted_258 = {
  key: 1,
  class: "form"
}
const _hoisted_259 = { key: 0 }
const _hoisted_260 = { class: "clubform-group" }
const _hoisted_261 = { class: "layout gutter--xl" }
const _hoisted_262 = { class: "row justify--center" }
const _hoisted_263 = { class: "md12 flex" }
const _hoisted_264 = { class: "row justify--center" }
const _hoisted_265 = {
  class: "md12 flex",
  style: {"padding-bottom":"64px"}
}
const _hoisted_266 = { class: "row" }
const _hoisted_267 = { class: "md6 flex" }
const _hoisted_268 = { class: "md3 flex" }
const _hoisted_269 = { class: "md3 flex" }
const _hoisted_270 = { class: "row" }
const _hoisted_271 = { class: "md6 flex" }
const _hoisted_272 = { class: "md6 flex" }
const _hoisted_273 = { class: "row" }
const _hoisted_274 = { class: "md6 flex" }
const _hoisted_275 = { class: "md6 flex" }
const _hoisted_276 = { class: "row" }
const _hoisted_277 = { class: "md4 flex" }
const _hoisted_278 = { class: "md4 flex" }
const _hoisted_279 = { class: "md4 flex" }
const _hoisted_280 = { class: "row" }
const _hoisted_281 = { class: "md6 flex" }
const _hoisted_282 = { class: "md6 flex" }
const _hoisted_283 = { class: "row align--baseline" }
const _hoisted_284 = { class: "flex md6" }
const _hoisted_285 = { class: "row justify--center" }
const _hoisted_286 = { class: "flex" }
const _hoisted_287 = /*#__PURE__*/_createTextVNode("Opret klub")
const _hoisted_288 = {
  key: 1,
  class: "layout gutter--xl center"
}
const _hoisted_289 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row justify--center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex" }, [
    /*#__PURE__*/_createElementVNode("h6", { class: "display-6" }, "Klubben er succesfuldt oprettet i systemet.")
  ])
], -1))
const _hoisted_290 = { class: "row justify--center" }
const _hoisted_291 = { class: "flex" }
const _hoisted_292 = /*#__PURE__*/_createTextVNode("Fortsæt")
const _hoisted_293 = { class: "layout gutter--xl" }
const _hoisted_294 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row justify--center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex" }, [
    /*#__PURE__*/_createElementVNode("h6", { class: "display-6" }, "Åbningstider")
  ])
], -1))
const _hoisted_295 = { class: "row align--center" }
const _hoisted_296 = { class: "flex md10" }
const _hoisted_297 = { class: "row align--center" }
const _hoisted_298 = { class: "flex md6" }
const _hoisted_299 = { class: "flex md3" }
const _hoisted_300 = { class: "flex md3" }
const _hoisted_301 = { class: "row align--center" }
const _hoisted_302 = { class: "flex md12" }
const _hoisted_303 = { class: "flex md2" }
const _hoisted_304 = /*#__PURE__*/_createTextVNode("Tilføj")
const _hoisted_305 = { class: "flex md10" }
const _hoisted_306 = { class: "row align--center" }
const _hoisted_307 = { class: "flex md6" }
const _hoisted_308 = { class: "flex md3" }
const _hoisted_309 = { class: "flex md3" }
const _hoisted_310 = {
  key: 0,
  class: "row align--center"
}
const _hoisted_311 = { class: "flex md12" }
const _hoisted_312 = { class: "comment" }
const _hoisted_313 = { class: "flex md2" }
const _hoisted_314 = ["onClick"]
const _hoisted_315 = { class: "row justify--center" }
const _hoisted_316 = { class: "flex" }
const _hoisted_317 = /*#__PURE__*/_createTextVNode("Ok")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_va_tab = _resolveComponent("va-tab")!
  const _component_va_tabs = _resolveComponent("va-tabs")!
  const _component_va_icon = _resolveComponent("va-icon")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_popover = _resolveComponent("va-popover")!
  const _component_va_input = _resolveComponent("va-input")!
  const _component_va_select = _resolveComponent("va-select")!
  const _component_va_slider = _resolveComponent("va-slider")!
  const _component_va_button_dropdown = _resolveComponent("va-button-dropdown")!
  const _component_va_checkbox = _resolveComponent("va-checkbox")!
  const _component_it_divider = _resolveComponent("it-divider")!
  const _component_va_button_group = _resolveComponent("va-button-group")!
  const _component_va_modal = _resolveComponent("va-modal")!
  const _component_it_drawer = _resolveComponent("it-drawer")!
  const _component_va_card_title = _resolveComponent("va-card-title")!
  const _component_QuillEditor = _resolveComponent("QuillEditor")!
  const _component_va_card_content = _resolveComponent("va-card-content")!
  const _component_va_card = _resolveComponent("va-card")!
  const _component_va_file_upload = _resolveComponent("va-file-upload")!
  const _component_it_modal = _resolveComponent("it-modal")!
  const _component_it_icon = _resolveComponent("it-icon")!
  const _component_it_button = _resolveComponent("it-button")!
  const _component_it_button_group = _resolveComponent("it-button-group")!
  const _component_va_chip = _resolveComponent("va-chip")!
  const _component_va_form = _resolveComponent("va-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.msg), 1),
      _createVNode(_component_va_tabs, {
        class: "adminTabs",
        modelValue: _ctx.tabValue,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tabValue) = $event))
      }, {
        tabs: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['Vis og rediger klubber', 'Opret ny klub'], (title) => {
            return _createVNode(_component_va_tab, {
              key: title,
              name: title
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(title), 1)
              ]),
              _: 2
            }, 1032, ["name"])
          }), 64))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _withDirectives(_createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_va_popover, {
              color: "primary",
              message: "Nulstil kolonner"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_button, {
                  class: "btn",
                  rounded: false,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.columnSort('reset')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_va_icon, {
                      class: "reset",
                      name: "autorenew"
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_va_input, {
              modelValue: _ctx.clubSearchInputValue,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.clubSearchInputValue) = $event)),
              label: "Søg",
              onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.findClub()), ["enter"]))
            }, {
              prependInner: _withCtx(() => [
                _createVNode(_component_va_icon, { name: "travel_explore" })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_va_button, {
              size: "small",
              class: "btn ml-2",
              rounded: false,
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.findClub()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_icon, { name: "search" }),
                _hoisted_8
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_va_select, {
              label: "Licensstatus",
              class: "ml-4",
              modelValue: _ctx.filterStatusStringValue,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filterStatusStringValue) = $event)),
              options: _ctx.filterStatusStringOptions,
              bordered: "",
              style: {"width":"75%"}
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_va_select, {
              label: "Region",
              class: "ml-4",
              modelValue: _ctx.klubRegionFilterValue,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.klubRegionFilterValue) = $event)),
              options: _ctx.klubRegionFilterOptions,
              "text-by": (klubRegionFilterOptions) => klubRegionFilterOptions.name,
              "track-by": (klubRegionFilterOptions) => klubRegionFilterOptions.id,
              bordered: ""
            }, null, 8, ["modelValue", "options", "text-by", "track-by"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_va_button_dropdown, {
              label: "Eksporter",
              modelValue: _ctx.exportDropDown,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.exportDropDown) = $event)),
              "close-on-content-click": false
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createVNode(_component_va_slider, {
                      modelValue: _ctx.ageRange,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.ageRange) = $event)),
                      range: "",
                      "track-label-visible": ""
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_va_select, {
                      label: "Kun klubber i region",
                      bordered: "",
                      modelValue: _ctx.exportRegionFilterValue,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.exportRegionFilterValue) = $event)),
                      options: _ctx.exportRegionFilterOptions,
                      "text-by": (exportRegionFilterOptions) => exportRegionFilterOptions.name,
                      "track-by": (exportRegionFilterOptions) => exportRegionFilterOptions.id
                    }, null, 8, ["modelValue", "options", "text-by", "track-by"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_va_select, {
                      label: "KlubStatus",
                      modelValue: _ctx.klubberStatusFilter,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.klubberStatusFilter) = $event)),
                      options: _ctx.klubberFilterStatusOptions,
                      "text-by": (klubberFilterStatusOptions) => klubberFilterStatusOptions.name,
                      "track-by": (klubberFilterStatusOptions) => klubberFilterStatusOptions.value,
                      bordered: ""
                    }, null, 8, ["modelValue", "options", "text-by", "track-by"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_va_select, {
                      label: "Vælg felter til at inkludere",
                      searchable: "",
                      modelValue: _ctx.exportFieldsFilterValue,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.exportFieldsFilterValue) = $event)),
                      multiple: "",
                      options: _ctx.exportFieldsFilterOptions,
                      "text-by": (exportFieldsFilterOptions) => exportFieldsFilterOptions.name,
                      bordered: ""
                    }, null, 8, ["modelValue", "options", "text-by"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(_component_va_button, {
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.exportDataToExcel())),
                      disabled: (!_ctx.exportFieldsFilterValue?.length > 0 && _ctx.loadingDataFlag === false)
                    }, {
                      default: _withCtx(() => [
                        _hoisted_23
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createVNode(_component_va_button, {
              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.giveManagerRights()))
            }, {
              default: _withCtx(() => [
                _hoisted_25
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          _createElementVNode("div", _hoisted_28, [
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.columnName,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.columnName) = $event)),
              "array-value": "licenseStatus",
              label: "Licensstatus"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.columnName,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.columnName) = $event)),
              "array-value": "name",
              label: "Navn"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.columnName,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.columnName) = $event)),
              "array-value": "established",
              label: "Etableret"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.columnName,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.columnName) = $event)),
              "array-value": "handicap",
              label: "Kørestolsvenlig"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.columnName,
              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.columnName) = $event)),
              "array-value": "region",
              label: "Region"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.columnName,
              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.columnName) = $event)),
              "array-value": "city",
              label: "By"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.columnName,
              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.columnName) = $event)),
              "array-value": "telephone",
              label: "Telefon"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.columnName,
              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.columnName) = $event)),
              "array-value": "mail",
              label: "Email"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.columnName,
              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.columnName) = $event)),
              "array-value": "balance",
              label: "Saldo"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.columnName,
              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.columnName) = $event)),
              "array-value": "opening",
              label: "Åbningstider"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.columnName,
              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.columnName) = $event)),
              "array-value": "members",
              label: "Medlemmer"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.columnName,
              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.columnName) = $event)),
              "array-value": "teams",
              label: "Hold"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.columnName,
              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.columnName) = $event)),
              "array-value": "webpage",
              label: "Hjemmeside"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.columnName,
              "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.columnName) = $event)),
              "array-value": "facebook",
              label: "Facebook"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createVNode(_component_it_divider),
        (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(_ctx.error), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_30, [
              _createElementVNode("table", _hoisted_31, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _withDirectives(_createElementVNode("th", null, "Licensstatus", 512), [
                      [_vShow, _ctx.showColumn('licenseStatus')]
                    ]),
                    _withDirectives(_createElementVNode("th", {
                      class: "sorting",
                      onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.columnSort('klubnavn')))
                    }, "Klubnavn", 512), [
                      [_vShow, _ctx.showColumn('name')]
                    ]),
                    _withDirectives(_createElementVNode("th", {
                      class: "sorting",
                      onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.columnSort('etableret')))
                    }, "Etableret", 512), [
                      [_vShow, _ctx.showColumn('established')]
                    ]),
                    _withDirectives(_createElementVNode("th", {
                      class: "sorting",
                      onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.columnSort('handicap')))
                    }, "Kørestolsvenlig", 512), [
                      [_vShow, _ctx.showColumn('handicap')]
                    ]),
                    _withDirectives(_createElementVNode("th", {
                      class: "sorting",
                      onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.columnSort('region')))
                    }, "Region", 512), [
                      [_vShow, _ctx.showColumn('region')]
                    ]),
                    _withDirectives(_createElementVNode("th", {
                      class: "sorting",
                      onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.columnSort('by')))
                    }, "By", 512), [
                      [_vShow, _ctx.showColumn('city')]
                    ]),
                    _withDirectives(_createElementVNode("th", {
                      class: "center sorting",
                      onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.columnSort('telefon')))
                    }, "Telefonnummer", 512), [
                      [_vShow, _ctx.showColumn('telephone')]
                    ]),
                    _withDirectives(_createElementVNode("th", {
                      class: "sorting",
                      onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.columnSort('email')))
                    }, "Email", 512), [
                      [_vShow, _ctx.showColumn('mail')]
                    ]),
                    _withDirectives(_createElementVNode("th", {
                      class: "center sorting",
                      onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.columnSort('saldo')))
                    }, "Saldo", 512), [
                      [_vShow, _ctx.showColumn('balance')]
                    ]),
                    _withDirectives(_createElementVNode("th", _hoisted_32, "Rediger åbningstider", 512), [
                      [_vShow, _ctx.showColumn('opening')]
                    ]),
                    _withDirectives(_createElementVNode("th", _hoisted_33, "Rediger medlemmer", 512), [
                      [_vShow, _ctx.showColumn('members')]
                    ]),
                    _withDirectives(_createElementVNode("th", _hoisted_34, "Rediger hold", 512), [
                      [_vShow, _ctx.showColumn('teams')]
                    ]),
                    _withDirectives(_createElementVNode("th", {
                      class: "sorting center",
                      onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.columnSort('hjemmeside')))
                    }, "Hjemmeside", 512), [
                      [_vShow, _ctx.showColumn('webpage')]
                    ]),
                    _withDirectives(_createElementVNode("th", {
                      class: "sorting center",
                      onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.columnSort('facebook')))
                    }, "Facebook", 512), [
                      [_vShow, _ctx.showColumn('facebook')]
                    ]),
                    _hoisted_35
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.klubbers, (klub, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: klub.id
                    }, [
                      _createElementVNode("td", {
                        id: 'clubstable-row' + (index+1),
                        hidden: ""
                      }, _toDisplayString(klub.id), 9, _hoisted_36),
                      _withDirectives(_createElementVNode("td", {
                        id: 'clubstable-row' + (index+1)
                      }, [
                        _createVNode(_component_va_icon, {
                          name: _ctx.activeLicense(klub.klubber_kontingent_slut) ? 'check_box': 'check_box_outline_blank',
                          color: _ctx.activeLicense(klub.klubber_kontingent_slut) ? 'primary' : 'rgb(255, 172, 10)'
                        }, null, 8, ["name", "color"])
                      ], 8, _hoisted_37), [
                        [_vShow, _ctx.showColumn('licenseStatus')]
                      ]),
                      _withDirectives(_createElementVNode("td", {
                        id: 'clubstable-row' + (index+1)
                      }, _toDisplayString(klub.klubber_klubnavn), 9, _hoisted_38), [
                        [_vShow, _ctx.showColumn('name')]
                      ]),
                      _withDirectives(_createElementVNode("td", {
                        id: 'clubstable-row' + (index+1)
                      }, _toDisplayString(_ctx.toDanishDateString(klub.klubber_etableringsaar)), 9, _hoisted_39), [
                        [_vShow, _ctx.showColumn('established')]
                      ]),
                      _withDirectives(_createElementVNode("td", {
                        id: 'clubstable-row' + (index+1),
                        class: "center"
                      }, [
                        _createVNode(_component_va_icon, {
                          name: klub.klubber_koerestolsvenlig === 'Ja' ? 'check' : '',
                          color: "success"
                        }, null, 8, ["name"])
                      ], 8, _hoisted_40), [
                        [_vShow, _ctx.showColumn('handicap')]
                      ]),
                      _withDirectives(_createElementVNode("td", {
                        id: 'clubstable-row' + (index+1)
                      }, _toDisplayString((klub.region_id === null ? '-' : klub?.region_id?.region_navn)), 9, _hoisted_41), [
                        [_vShow, _ctx.showColumn('region')]
                      ]),
                      _withDirectives(_createElementVNode("td", {
                        id: 'clubstable-row' + (index+1)
                      }, _toDisplayString(klub?.bypost_id?.bypost_by), 9, _hoisted_42), [
                        [_vShow, _ctx.showColumn('city')]
                      ]),
                      _withDirectives(_createElementVNode("td", {
                        id: 'clubstable-row' + (index+1),
                        class: "center"
                      }, [
                        _createElementVNode("a", {
                          href: 'tel:' + klub.klubber_telefonnummer
                        }, _toDisplayString(klub.klubber_telefonnummer), 9, _hoisted_44)
                      ], 8, _hoisted_43), [
                        [_vShow, _ctx.showColumn('telephone')]
                      ]),
                      _withDirectives(_createElementVNode("td", {
                        id: 'clubstable-row' + (index+1)
                      }, [
                        _createElementVNode("a", {
                          href: 'mailto:' + klub.klubber_email
                        }, _toDisplayString(klub.klubber_email), 9, _hoisted_46)
                      ], 8, _hoisted_45), [
                        [_vShow, _ctx.showColumn('mail')]
                      ]),
                      _withDirectives(_createElementVNode("td", {
                        id: 'clubstable-row' + (index+1),
                        class: "saldo center sorting"
                      }, [
                        _createVNode(_component_va_button, {
                          class: "btn balancebutton",
                          rounded: false,
                          onClick: ($event: any) => (_ctx.changeSaldoClub(klub.id, klub.documentId))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(klub.klubber_saldo), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ], 8, _hoisted_47), [
                        [_vShow, _ctx.showColumn('balance')]
                      ]),
                      _withDirectives(_createElementVNode("td", {
                        id: 'clubstable-row' + (index+1),
                        class: "center"
                      }, [
                        _createVNode(_component_va_button, {
                          class: "btn",
                          rounded: false,
                          onClick: ($event: any) => (_ctx.editOpeningHours(klub.id, klub.klubber_klubnavn))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_49
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ], 8, _hoisted_48), [
                        [_vShow, _ctx.showColumn('opening')]
                      ]),
                      _withDirectives(_createElementVNode("td", {
                        id: 'clubstable-row' + (index+1),
                        class: "center"
                      }, [
                        _createVNode(_component_va_button, {
                          class: "btn",
                          rounded: false,
                          name: "editmembersclub",
                          onClick: ($event: any) => (_ctx.editMembersClub(klub.id, klub.documentId))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_51
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ], 8, _hoisted_50), [
                        [_vShow, _ctx.showColumn('members')]
                      ]),
                      _withDirectives(_createElementVNode("td", {
                        id: 'clubstable-row' + (index+1),
                        class: "center"
                      }, [
                        _createVNode(_component_va_button, {
                          class: "btn",
                          rounded: false,
                          name: "editteamclub",
                          onClick: ($event: any) => (_ctx.editTeamClub(klub.id, klub.documentId))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_53
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ], 8, _hoisted_52), [
                        [_vShow, _ctx.showColumn('teams')]
                      ]),
                      (klub.klubber_hjemmeside === null)
                        ? _withDirectives((_openBlock(), _createElementBlock("td", {
                            key: 0,
                            id: 'clubstable-row' + (index+1),
                            class: "center"
                          }, "Ingen", 8, _hoisted_54)), [
                            [_vShow, _ctx.showColumn('webpage')]
                          ])
                        : _withDirectives((_openBlock(), _createElementBlock("td", {
                            key: 1,
                            id: 'clubstable-row' + (index+1),
                            class: "center"
                          }, [
                            _createElementVNode("a", {
                              href: klub.klubber_hjemmeside,
                              target: "_blank",
                              rel: "noopener"
                            }, _toDisplayString(klub.klubber_hjemmeside), 9, _hoisted_56)
                          ], 8, _hoisted_55)), [
                            [_vShow, _ctx.showColumn('webpage')]
                          ]),
                      (klub.klubber_facebook === null)
                        ? _withDirectives((_openBlock(), _createElementBlock("td", {
                            key: 2,
                            id: 'clubstable-row' + (index+1),
                            class: "center"
                          }, "Ingen", 8, _hoisted_57)), [
                            [_vShow, _ctx.showColumn('facebook')]
                          ])
                        : _withDirectives((_openBlock(), _createElementBlock("td", {
                            key: 3,
                            id: 'clubstable-row' + (index+1),
                            class: "center"
                          }, [
                            _createElementVNode("a", {
                              href: klub.klubber_facebook,
                              target: "_blank",
                              rel: "noopener"
                            }, "Facebook", 8, _hoisted_59)
                          ], 8, _hoisted_58)), [
                            [_vShow, _ctx.showColumn('facebook')]
                          ]),
                      _createElementVNode("td", {
                        id: 'clubstable-row' + (index+1)
                      }, [
                        _createVNode(_component_va_button_group, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_va_button, {
                              color: "info",
                              class: "btn",
                              name: "editclub",
                              onClick: ($event: any) => (_ctx.editClub(klub.id, klub.documentId))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_61
                              ]),
                              _: 2
                            }, 1032, ["onClick"]),
                            _createVNode(_component_va_button, {
                              icon: klub.klubber_status ? 'check_box' : 'check_box_outline_blank',
                              color: klub.klubber_status ? 'success' : 'rgb(255, 172, 10)',
                              class: "btn status-width",
                              name: "blockclub",
                              onClick: ($event: any) => (_ctx.blockClub(klub.documentId))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(klub.klubber_status ? 'Aktiv' : 'Inaktiv'), 1)
                              ]),
                              _: 2
                            }, 1032, ["icon", "color", "onClick"]),
                            _createVNode(_component_va_button, {
                              color: "danger",
                              class: "btn",
                              name: "deleteclub",
                              onClick: ($event: any) => (_ctx.deleteClubWarning(klub.id, klub.klubber_klubnavn, klub.documentId))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_62
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _: 2
                        }, 1024)
                      ], 8, _hoisted_60)
                    ]))
                  }), 128))
                ])
              ])
            ])),
        _createElementVNode("div", _hoisted_63, [
          _createVNode(_component_va_button, {
            icon: "first_page",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.jumpToPage(1)))
          }),
          _createVNode(_component_va_button, {
            icon: "keyboard_double_arrow_left",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.turnToNewPage(-5)))
          }),
          _createVNode(_component_va_button, {
            icon: "chevron_left",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.turnToNewPage(-1)))
          }),
          _hoisted_64,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.currentPage) = $event)),
            type: "number",
            onKeyup: _cache[42] || (_cache[42] = _withKeys(($event: any) => (_ctx.jumpToPage(this.currentPage)), ["enter"]))
          }, null, 544), [
            [_vModelText, _ctx.currentPage]
          ]),
          (_ctx.totalNumberOfPages === 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_65, " af " + _toDisplayString(_ctx.totalNumberOfPages+1), 1))
            : (_openBlock(), _createElementBlock("p", _hoisted_66, " af " + _toDisplayString(_ctx.totalNumberOfPages), 1)),
          _createVNode(_component_va_button, {
            icon: "chevron_right",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[43] || (_cache[43] = ($event: any) => (_ctx.turnToNewPage(1)))
          }),
          _createVNode(_component_va_button, {
            icon: "keyboard_double_arrow_right",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[44] || (_cache[44] = ($event: any) => (_ctx.turnToNewPage(5)))
          }),
          _createVNode(_component_va_button, {
            icon: "last_page",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[45] || (_cache[45] = ($event: any) => (_ctx.jumpToPage(this.totalNumberOfPages)))
          }),
          _hoisted_67,
          _createElementVNode("div", _hoisted_68, [
            _createVNode(_component_va_select, {
              class: "mr-2",
              modelValue: _ctx.pageSizeValueString,
              "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.pageSizeValueString) = $event)),
              options: _ctx.pageSizeOptions,
              bordered: ""
            }, null, 8, ["modelValue", "options"])
          ])
        ]),
        _createVNode(_component_va_modal, {
          modelValue: _ctx.exportModal,
          "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.exportModal) = $event)),
          "hide-default-actions": ""
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_va_button, {
              onClick: _cache[48] || (_cache[48] = ($event: any) => (_ctx.exportDataToExcel()))
            }, {
              default: _withCtx(() => [
                _hoisted_69
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_va_select, {
              modelValue: _ctx.exportFilterValue,
              "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.exportFilterValue) = $event)),
              multiple: "",
              options: _ctx.exportFilterOptions,
              "text-by": (exportFilterOptions) => exportFilterOptions.name
            }, null, 8, ["modelValue", "options", "text-by"])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_it_drawer, {
          modelValue: _ctx.editOpeningHoursDrawerVisible,
          "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((_ctx.editOpeningHoursDrawerVisible) = $event)),
          width: "750px"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_70, [
              _hoisted_71,
              _createElementVNode("div", _hoisted_72, [
                _createElementVNode("div", _hoisted_73, [
                  _createElementVNode("div", _hoisted_74, [
                    _createElementVNode("div", _hoisted_75, [
                      _createVNode(_component_va_select, {
                        modelValue: _ctx.openingHoursDayValue,
                        "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.openingHoursDayValue) = $event)),
                        label: "Dag",
                        options: _ctx.openingHoursDayOptions,
                        bordered: ""
                      }, null, 8, ["modelValue", "options"])
                    ]),
                    _createElementVNode("div", _hoisted_76, [
                      _createVNode(_component_va_input, {
                        type: "time",
                        label: "Fra",
                        modelValue: _ctx.openingData.open,
                        "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.openingData.open) = $event)),
                        bordered: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_77, [
                      _createVNode(_component_va_input, {
                        type: "time",
                        label: "Til",
                        modelValue: _ctx.openingData.close,
                        "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.openingData.close) = $event)),
                        bordered: ""
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_78, [
                    _createElementVNode("div", _hoisted_79, [
                      _createVNode(_component_va_input, {
                        type: "text",
                        label: "Evt. kommentar",
                        modelValue: _ctx.openingData.comment,
                        "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.openingData.comment) = $event)),
                        bordered: ""
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_80, [
                  _createVNode(_component_va_button, {
                    size: "small",
                    color: "success",
                    onClick: _cache[54] || (_cache[54] = ($event: any) => (_ctx.addOpeningHoursToClub()))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_81
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createVNode(_component_it_divider),
              _createElementVNode("div", _hoisted_82, [
                _createElementVNode("div", _hoisted_83, [
                  _createElementVNode("div", _hoisted_84, [
                    _createElementVNode("h6", _hoisted_85, "Nuværende åbningstider for " + _toDisplayString(this.lastEditClubName), 1)
                  ])
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.openingHours, (openingHour, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: openingHour.id,
                  class: "openinghourcontainer"
                }, [
                  _createElementVNode("div", _hoisted_86, [
                    _createElementVNode("div", _hoisted_87, [
                      _createElementVNode("div", _hoisted_88, [
                        _createVNode(_component_va_select, {
                          modelValue: openingHour.aabningstider_dag,
                          "onUpdate:modelValue": ($event: any) => ((openingHour.aabningstider_dag) = $event),
                          options: _ctx.openingHoursDayOptions,
                          label: "Dag",
                          bordered: ""
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
                      ]),
                      _createElementVNode("div", _hoisted_89, [
                        _createVNode(_component_va_input, {
                          modelValue: openingHour.aabningstider_aaben,
                          "onUpdate:modelValue": ($event: any) => ((openingHour.aabningstider_aaben) = $event),
                          type: "time",
                          label: "Fra",
                          bordered: ""
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_90, [
                        _createVNode(_component_va_input, {
                          modelValue: openingHour.aabningstider_luk,
                          "onUpdate:modelValue": ($event: any) => ((openingHour.aabningstider_luk) = $event),
                          type: "time",
                          label: "Til",
                          bordered: ""
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _hoisted_91
                    ]),
                    _createElementVNode("div", _hoisted_92, [
                      _createElementVNode("div", _hoisted_93, [
                        _createVNode(_component_va_input, {
                          label: "Evt. kommentar",
                          type: "text",
                          modelValue: openingHour.aabningstider_kommentar,
                          "onUpdate:modelValue": ($event: any) => ((openingHour.aabningstider_kommentar) = $event),
                          bordered: ""
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_94, [
                      _createElementVNode("div", _hoisted_95, [
                        _createVNode(_component_va_button_group, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_va_button, {
                              onClick: ($event: any) => (_ctx.updateOpeningHour(index, openingHour.id)),
                              color: "success"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_96
                              ]),
                              _: 2
                            }, 1032, ["onClick"]),
                            _createVNode(_component_va_button, {
                              onClick: ($event: any) => (_ctx.deleteOpeningHourWarning(openingHour.id)),
                              color: "danger"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_97
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _: 2
                        }, 1024)
                      ])
                    ])
                  ])
                ]))
              }), 128)),
              _createVNode(_component_it_divider)
            ]),
            _createElementVNode("div", _hoisted_98, [
              _createElementVNode("div", _hoisted_99, [
                _createVNode(_component_va_button, {
                  onClick: _cache[55] || (_cache[55] = ($event: any) => (_ctx.editOpeningHoursDrawerVisible = false))
                }, {
                  default: _withCtx(() => [
                    _hoisted_100
                  ]),
                  _: 1
                })
              ])
            ]),
            _createVNode(_component_va_modal, {
              modelValue: _ctx.deleteOpeningHoursWarningModal,
              "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((_ctx.deleteOpeningHoursWarningModal) = $event)),
              size: "small",
              "overlay-opacity": "0.5",
              "hide-default-actions": ""
            }, {
              footer: _withCtx(() => [
                _createVNode(_component_va_button, {
                  class: "btn mr-4",
                  color: "danger",
                  onClick: _cache[56] || (_cache[56] = ($event: any) => (_ctx.deleteOpeningHour(this.deleteOpeningHourId), _ctx.$Message.success({ text: 'Åbningstiden er blevet slettet' })))
                }, {
                  default: _withCtx(() => [
                    _hoisted_102
                  ]),
                  _: 1
                }),
                _createVNode(_component_va_button, {
                  class: "btn mr-4",
                  color: "secondary",
                  onClick: _cache[57] || (_cache[57] = ($event: any) => (_ctx.deleteOpeningHoursWarningModal = false, _ctx.$Message.warning({ text: 'Annulleret' })))
                }, {
                  default: _withCtx(() => [
                    _hoisted_103
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _hoisted_101
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_va_modal, {
          modelValue: _ctx.deleteClubWarningModal,
          "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ((_ctx.deleteClubWarningModal) = $event)),
          "hide-default-actions": "",
          "overlay-opacity": "0.5",
          color: "danger"
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_va_button, {
              class: "btn mr-4",
              color: "danger",
              onClick: _cache[60] || (_cache[60] = ($event: any) => (_ctx.deleteClub(this.deleteClubId, this.deleteClubDocumentId), _ctx.$Message.success({ text: 'Klubben er blevet slettet' })))
            }, {
              default: _withCtx(() => [
                _hoisted_110
              ]),
              _: 1
            }),
            _createVNode(_component_va_button, {
              class: "btn mr-4",
              color: "secondary",
              onClick: _cache[61] || (_cache[61] = ($event: any) => (_ctx.deleteClubWarningModal = false, _ctx.$Message.warning({ text: 'Annulleret' })))
            }, {
              default: _withCtx(() => [
                _hoisted_111
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_104, [
              _createElementVNode("div", _hoisted_105, [
                _createElementVNode("div", _hoisted_106, [
                  _createElementVNode("p", _hoisted_107, [
                    _hoisted_108,
                    _createElementVNode("strong", null, _toDisplayString(this.deleteClubName), 1),
                    _hoisted_109
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_va_modal, {
          modelValue: _ctx.editClubModal,
          "onUpdate:modelValue": _cache[86] || (_cache[86] = ($event: any) => ((_ctx.editClubModal) = $event)),
          size: "large",
          "hide-default-actions": "",
          "overlay-opacity": "0.5",
          "no-dismiss": ""
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_va_button, {
              class: "btn mr-4",
              color: "success",
              onClick: _cache[84] || (_cache[84] = ($event: any) => (_ctx.updateClub()))
            }, {
              default: _withCtx(() => [
                _hoisted_144
              ]),
              _: 1
            }),
            _createVNode(_component_va_button, {
              class: "btn mr-4",
              color: "secondary",
              onClick: _cache[85] || (_cache[85] = ($event: any) => (_ctx.$Message.warning({ text: 'Redigeringen blev annulleret' }), (_ctx.editClubModal = false)))
            }, {
              default: _withCtx(() => [
                _hoisted_145
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_112, [
              _createElementVNode("div", _hoisted_113, [
                _createElementVNode("div", _hoisted_114, [
                  _createElementVNode("div", _hoisted_115, [
                    _createElementVNode("h6", _hoisted_116, _toDisplayString(_ctx.klubData.klubKlubnavn), 1)
                  ]),
                  _createElementVNode("div", _hoisted_117, [
                    _createElementVNode("img", {
                      class: "logoImg",
                      src: _ctx.extractLogoURLFromClubLogoData(_ctx.klubData.klubLogo),
                      label: "Klublogo"
                    }, null, 8, _hoisted_118)
                  ])
                ]),
                _createVNode(_component_va_card, {
                  color: "#afcfff",
                  gradient: true,
                  stripe: true,
                  "stripe-color": "#255f4f"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_va_card_title, null, {
                      default: _withCtx(() => [
                        _hoisted_119
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_va_card_content, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_120, [
                          _createElementVNode("div", _hoisted_121, [
                            _createVNode(_component_va_input, {
                              type: "text",
                              modelValue: _ctx.klubData.klubKlubnavn,
                              "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => ((_ctx.klubData.klubKlubnavn) = $event)),
                              label: "Klubnavn",
                              bordered: "",
                              rules: [(klubKlubnavn) => _ctx.klubData.klubKlubnavn?.length > 1 || 'Klubnavn mangler']
                            }, null, 8, ["modelValue", "rules"])
                          ]),
                          _createElementVNode("div", _hoisted_122, [
                            _createVNode(_component_va_button, {
                              onClick: _cache[64] || (_cache[64] = ($event: any) => (_ctx.newClubLogo()))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_123
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_124, [
                            _createVNode(_component_va_checkbox, {
                              modelValue: _ctx.klubData.klubKoerestolsvenlig,
                              "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => ((_ctx.klubData.klubKoerestolsvenlig) = $event)),
                              label: "Klubben er kørestolsvenlig",
                              "left-label": ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_125, [
                            _createVNode(_component_va_input, {
                              type: "text",
                              modelValue: _ctx.klubData.klubVejnavn,
                              "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => ((_ctx.klubData.klubVejnavn) = $event)),
                              label: "Adresse",
                              placeholder: "Adresse",
                              bordered: "",
                              rules: [(klubVejnavn) => _ctx.klubData.klubVejnavn?.length > 1 || 'Der mangler en adresse']
                            }, null, 8, ["modelValue", "rules"])
                          ]),
                          _createElementVNode("div", _hoisted_126, [
                            _createVNode(_component_va_input, {
                              type: "number",
                              modelValue: _ctx.klubData.klubPostnummer,
                              "onUpdate:modelValue": _cache[67] || (_cache[67] = ($event: any) => ((_ctx.klubData.klubPostnummer) = $event)),
                              onFocus: _cache[68] || (_cache[68] = ($event: any) => (_ctx.medlemByPostnummerInputFocus = 2)),
                              label: "Postnummer",
                              placeholder: "Nr.",
                              bordered: "",
                              rules: [(klubPostnummer) => _ctx.klubData.klubPostnummer?.length === 4 || 'Postnummer mangler']
                            }, null, 8, ["modelValue", "rules"])
                          ]),
                          _createElementVNode("div", _hoisted_127, [
                            _createVNode(_component_va_input, {
                              type: "text",
                              modelValue: _ctx.klubData.klubBy,
                              "onUpdate:modelValue": _cache[69] || (_cache[69] = ($event: any) => ((_ctx.klubData.klubBy) = $event)),
                              onFocus: _cache[70] || (_cache[70] = ($event: any) => (_ctx.medlemByPostnummerInputFocus = 1)),
                              label: "By",
                              placeholder: "By",
                              bordered: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_128, [
                            _createVNode(_component_va_input, {
                              type: "number",
                              modelValue: _ctx.klubData.klubTelefonnummer,
                              "onUpdate:modelValue": _cache[71] || (_cache[71] = ($event: any) => ((_ctx.klubData.klubTelefonnummer) = $event)),
                              label: "Telefonnummer",
                              placeholder: "Nr.",
                              bordered: "",
                              rules: [(klubTelefonnummer) => _ctx.klubData.klubTelefonnummer.trim()?.length > 7 || 'Der mangler et telefonnummer']
                            }, null, 8, ["modelValue", "rules"])
                          ]),
                          _createElementVNode("div", _hoisted_129, [
                            _createVNode(_component_va_input, {
                              type: "email",
                              modelValue: _ctx.klubData.klubEmail,
                              "onUpdate:modelValue": _cache[72] || (_cache[72] = ($event: any) => ((_ctx.klubData.klubEmail) = $event)),
                              label: "Email",
                              placeholder: "mailuser@domain.tld",
                              bordered: "",
                              rules: [(klubEmail) => _ctx.klubData.klubEmail?.length > 2 && _ctx.klubData.klubEmail.includes('@') || 'Indtast venligst en korrekt email']
                            }, null, 8, ["modelValue", "rules"])
                          ]),
                          _createElementVNode("div", _hoisted_130, [
                            _createVNode(_component_va_input, {
                              type: "url",
                              modelValue: _ctx.klubData.klubHjemmeside,
                              "onUpdate:modelValue": _cache[73] || (_cache[73] = ($event: any) => ((_ctx.klubData.klubHjemmeside) = $event)),
                              label: "Hjemmeside",
                              placeholder: "Hjemmeside",
                              bordered: "",
                              rules: [(klubHjemmeside) => _ctx.klubData.klubHjemmeside === null || _ctx.klubData.klubHjemmeside?.length === 0 || _ctx.klubData.klubHjemmeside.includes('http://') || _ctx.klubData.klubHjemmeside.includes('https://') || 'Indtast en gyldig hjemmeside']
                            }, null, 8, ["modelValue", "rules"])
                          ]),
                          _createElementVNode("div", _hoisted_131, [
                            _createVNode(_component_va_input, {
                              type: "url",
                              modelValue: _ctx.klubData.klubFacebook,
                              "onUpdate:modelValue": _cache[74] || (_cache[74] = ($event: any) => ((_ctx.klubData.klubFacebook) = $event)),
                              label: "Facebook",
                              placeholder: "Facebook",
                              bordered: "",
                              rules: [(klubFacebook) => _ctx.klubData.klubFacebook === null || _ctx.klubData.klubFacebook?.length === 0 || _ctx.klubData.klubFacebook.includes('https://da-dk.facebook.com/') || _ctx.klubData.klubFacebook.includes('https://www.facebook.com/') || _ctx.klubData.klubFacebook.includes('https://facebook.com/') || 'Indtast en gyldig Facebook adresse']
                            }, null, 8, ["modelValue", "rules"])
                          ]),
                          _createElementVNode("div", _hoisted_132, [
                            _createVNode(_component_QuillEditor, {
                              ref: "clubDescription",
                              options: _ctx.quillToolbar,
                              contentType: "html",
                              content: _ctx.klubData.klubBeskrivelse,
                              "onUpdate:content": _cache[75] || (_cache[75] = ($event: any) => ((_ctx.klubData.klubBeskrivelse) = $event)),
                              class: "quillAdmClubDescription"
                            }, null, 8, ["options", "content"])
                          ]),
                          _createElementVNode("div", _hoisted_133, [
                            _createVNode(_component_va_select, {
                              modelValue: _ctx.klubRegionTrackByValue,
                              "onUpdate:modelValue": _cache[76] || (_cache[76] = ($event: any) => ((_ctx.klubRegionTrackByValue) = $event)),
                              options: _ctx.klubRegionTrackByOptions,
                              "text-by": "name",
                              "track-by": "id",
                              label: "Region",
                              bordered: ""
                            }, null, 8, ["modelValue", "options"])
                          ]),
                          _createElementVNode("div", _hoisted_134, [
                            (_ctx.klubData.klubEtableringsaar != null)
                              ? (_openBlock(), _createBlock(_component_va_input, {
                                  key: 0,
                                  type: "date",
                                  modelValue: _ctx.klubData.klubEtableringsaar,
                                  "onUpdate:modelValue": _cache[77] || (_cache[77] = ($event: any) => ((_ctx.klubData.klubEtableringsaar) = $event)),
                                  label: "Etableret den *",
                                  readonly: "",
                                  bordered: ""
                                }, null, 8, ["modelValue"]))
                              : (_openBlock(), _createBlock(_component_va_input, {
                                  key: 1,
                                  type: "text",
                                  placeholder: "Ikke opgivet",
                                  label: "Etableret den *",
                                  readonly: "",
                                  bordered: ""
                                }))
                          ]),
                          _createElementVNode("div", _hoisted_135, [
                            _createVNode(_component_va_input, {
                              type: "text",
                              modelValue: _ctx.klubData.klubHjemmekampe,
                              "onUpdate:modelValue": _cache[78] || (_cache[78] = ($event: any) => ((_ctx.klubData.klubHjemmekampe) = $event)),
                              label: "Hjemmekampe",
                              placeholder: "Antal",
                              bordered: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_136, [
                            _createVNode(_component_va_input, {
                              type: "number",
                              modelValue: _ctx.klubData.klubBaner,
                              "onUpdate:modelValue": _cache[79] || (_cache[79] = ($event: any) => ((_ctx.klubData.klubBaner) = $event)),
                              label: "Antal baner",
                              placeholder: "Antal",
                              bordered: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_137, [
                            _createVNode(_component_va_input, {
                              type: "number",
                              modelValue: _ctx.klubData.klubSaldo,
                              "onUpdate:modelValue": _cache[80] || (_cache[80] = ($event: any) => ((_ctx.klubData.klubSaldo) = $event)),
                              label: "saldo",
                              placeholder: "Beløb",
                              bordered: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_138, [
                            _createElementVNode("p", null, "Kontigent udløber: " + _toDisplayString(_ctx.toDanishDateString(_ctx.klubData.klubLicens)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_139, [
                            _createVNode(_component_va_button, {
                              color: "info",
                              disabled: _ctx.disableLicenseRenewalBtn(_ctx.klubData.klubLicens) && !_ctx.customLicenseEndDate,
                              onClick: _cache[81] || (_cache[81] = ($event: any) => (_ctx.renewLicense(_ctx.klubData.klubLicens)))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_140
                              ]),
                              _: 1
                            }, 8, ["disabled"])
                          ]),
                          _createElementVNode("div", _hoisted_141, [
                            _createVNode(_component_va_checkbox, {
                              modelValue: _ctx.customLicenseEndDate,
                              "onUpdate:modelValue": _cache[82] || (_cache[82] = ($event: any) => ((_ctx.customLicenseEndDate) = $event)),
                              label: "Angiv kontigent slutdato"
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_142, [
                            _withDirectives(_createVNode(_component_va_input, {
                              modelValue: _ctx.newLicenseEndDate,
                              "onUpdate:modelValue": _cache[83] || (_cache[83] = ($event: any) => ((_ctx.newLicenseEndDate) = $event)),
                              label: "Ny kontigent slutdato",
                              type: "date",
                              bordered: ""
                            }, null, 8, ["modelValue"]), [
                              [_vShow, _ctx.customLicenseEndDate]
                            ])
                          ])
                        ]),
                        _hoisted_143
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_it_modal, {
          modelValue: _ctx.displayImagesModal,
          "onUpdate:modelValue": _cache[103] || (_cache[103] = ($event: any) => ((_ctx.displayImagesModal) = $event)),
          width: "60%"
        }, {
          header: _withCtx(() => [
            _hoisted_146
          ]),
          body: _withCtx(() => [
            _createElementVNode("div", _hoisted_147, [
              _createElementVNode("div", _hoisted_148, [
                _createElementVNode("div", _hoisted_149, [
                  _createVNode(_component_va_button, {
                    class: "btn",
                    rounded: false,
                    onClick: _cache[87] || (_cache[87] = ($event: any) => (_ctx.resetSearch()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_va_icon, {
                        class: "reset",
                        name: "autorenew"
                      })
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_150, [
                  _createVNode(_component_va_input, {
                    modelValue: _ctx.imageSearchInputValue,
                    "onUpdate:modelValue": _cache[88] || (_cache[88] = ($event: any) => ((_ctx.imageSearchInputValue) = $event)),
                    label: "Søg",
                    onKeyup: _cache[89] || (_cache[89] = _withKeys(($event: any) => (_ctx.findImage()), ["enter"]))
                  }, {
                    prependInner: _withCtx(() => [
                      _createVNode(_component_va_icon, { name: "image_search" })
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_va_button, {
                    size: "small",
                    class: "btn ml-2",
                    rounded: false,
                    onClick: _cache[90] || (_cache[90] = ($event: any) => (_ctx.findImage()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_va_icon, { name: "search" }),
                      _hoisted_151
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_152, [
                  _createVNode(_component_va_file_upload, {
                    color: "success",
                    size: "small",
                    modelValue: _ctx.imageUpload,
                    "onUpdate:modelValue": _cache[91] || (_cache[91] = ($event: any) => ((_ctx.imageUpload) = $event)),
                    type: "single",
                    "file-types": ".jpg,.png,.jpeg"
                  }, null, 8, ["modelValue"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_153, [
              _createElementVNode("div", _hoisted_154, [
                _hoisted_155,
                _createElementVNode("img", {
                  src: _ctx.getImage(_ctx.selectedImage),
                  class: "imagessize"
                }, null, 8, _hoisted_156)
              ])
            ]),
            _createVNode(_component_it_divider),
            _createElementVNode("div", _hoisted_157, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imageFiles, (image) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "imageContainer",
                  key: image.id
                }, [
                  _createElementVNode("p", _hoisted_158, _toDisplayString((image.name).slice(0, 10) + '...'), 1),
                  _createElementVNode("label", _hoisted_159, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[92] || (_cache[92] = ($event: any) => ((_ctx.selectedImage) = $event)),
                      class: "imageRadio",
                      type: "radio",
                      name: "choosenImage",
                      value: image,
                      onClick: ($event: any) => (_ctx.uncheck(image))
                    }, null, 8, _hoisted_160), [
                      [_vModelRadio, _ctx.selectedImage]
                    ]),
                    _createElementVNode("img", {
                      src: _ctx.getImage(image),
                      class: "imagessize",
                      title: image.name
                    }, null, 8, _hoisted_161)
                  ])
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_162, [
              _createVNode(_component_va_button, {
                icon: "first_page",
                class: "mr-2",
                size: "small",
                rounded: false,
                onClick: _cache[93] || (_cache[93] = ($event: any) => (_ctx.jumpToImagePage(1)))
              }),
              _createVNode(_component_va_button, {
                icon: "keyboard_double_arrow_left",
                class: "mr-2",
                size: "small",
                rounded: false,
                onClick: _cache[94] || (_cache[94] = ($event: any) => (_ctx.turnToNewImagePage(-5)))
              }),
              _createVNode(_component_va_button, {
                icon: "chevron_left",
                class: "mr-2",
                size: "small",
                rounded: false,
                onClick: _cache[95] || (_cache[95] = ($event: any) => (_ctx.turnToNewImagePage(-1)))
              }),
              _hoisted_163,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[96] || (_cache[96] = ($event: any) => ((_ctx.currentImagePage) = $event)),
                onKeyup: _cache[97] || (_cache[97] = _withKeys(($event: any) => (_ctx.jumpToImagePage(this.currentImagePage)), ["enter"]))
              }, null, 544), [
                [_vModelText, _ctx.currentImagePage]
              ]),
              (_ctx.totalNumberOfImagePages === 0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_164, " af " + _toDisplayString(_ctx.totalNumberOfImagePages+1), 1))
                : (_openBlock(), _createElementBlock("p", _hoisted_165, " af " + _toDisplayString(_ctx.totalNumberOfImagePages), 1)),
              _createVNode(_component_va_button, {
                icon: "chevron_right",
                class: "mr-2",
                size: "small",
                rounded: false,
                onClick: _cache[98] || (_cache[98] = ($event: any) => (_ctx.turnToNewImagePage(1)))
              }),
              _createVNode(_component_va_button, {
                icon: "keyboard_double_arrow_right",
                class: "mr-2",
                size: "small",
                rounded: false,
                onClick: _cache[99] || (_cache[99] = ($event: any) => (_ctx.turnToNewImagePage(5)))
              }),
              _createVNode(_component_va_button, {
                icon: "last_page",
                class: "mr-2",
                size: "small",
                rounded: false,
                onClick: _cache[100] || (_cache[100] = ($event: any) => (_ctx.jumpToImagePage(this.totalNumberOfImagePages)))
              })
            ])
          ]),
          actions: _withCtx(() => [
            _createElementVNode("div", _hoisted_166, [
              _createElementVNode("div", _hoisted_167, [
                _createVNode(_component_va_button, {
                  class: "mr-2",
                  color: "success",
                  onClick: _cache[101] || (_cache[101] = ($event: any) => (_ctx.setNewClubLogo()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_168
                  ]),
                  _: 1
                }),
                _createVNode(_component_va_button, {
                  class: "ml-2",
                  color: "secondary",
                  onClick: _cache[102] || (_cache[102] = ($event: any) => (_ctx.displayImagesModal = false))
                }, {
                  default: _withCtx(() => [
                    _hoisted_169
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_va_modal, {
          modelValue: _ctx.editClubSaldoModal,
          "onUpdate:modelValue": _cache[107] || (_cache[107] = ($event: any) => ((_ctx.editClubSaldoModal) = $event)),
          size: "small",
          "hide-default-actions": "",
          "overlay-opacity": "0.5"
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_va_button, {
              class: "btn mr-4",
              color: "success",
              onClick: _cache[105] || (_cache[105] = ($event: any) => (_ctx.updateClubSaldo()))
            }, {
              default: _withCtx(() => [
                _hoisted_175
              ]),
              _: 1
            }),
            _createVNode(_component_va_button, {
              class: "btn mr-4",
              color: "secondary",
              onClick: _cache[106] || (_cache[106] = ($event: any) => (_ctx.$Message.warning({ text: 'Redigeringen blev annulleret' }), (_ctx.editClubSaldoModal = false)))
            }, {
              default: _withCtx(() => [
                _hoisted_176
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_170, [
              _createElementVNode("div", _hoisted_171, [
                _createElementVNode("p", _hoisted_172, "Rediger saldoen for " + _toDisplayString(_ctx.klubData.klubKlubnavn), 1)
              ]),
              _createElementVNode("div", _hoisted_173, [
                _createElementVNode("div", _hoisted_174, [
                  _createVNode(_component_va_input, {
                    class: "mb-4",
                    modelValue: _ctx.klubData.klubSaldo,
                    "onUpdate:modelValue": _cache[104] || (_cache[104] = ($event: any) => ((_ctx.klubData.klubSaldo) = $event)),
                    type: "number",
                    label: "Ny Saldo"
                  }, {
                    appendInner: _withCtx(() => [
                      _createVNode(_component_va_icon, {
                        name: "account_balance",
                        color: "#5555dd",
                        class: "inputfield-1"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_it_drawer, {
          placement: "left",
          width: "920px",
          modelValue: _ctx.addClubTeamsDrawerVisible,
          "onUpdate:modelValue": _cache[109] || (_cache[109] = ($event: any) => ((_ctx.addClubTeamsDrawerVisible) = $event))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_177, [
              _createElementVNode("span", _hoisted_178, [
                _createElementVNode("h6", _hoisted_179, [
                  _createVNode(_component_it_icon, {
                    box: "",
                    name: "groups"
                  }),
                  _hoisted_180
                ]),
                _createElementVNode("h4", _hoisted_181, " Klub: " + _toDisplayString(_ctx.lastEditMembersOfKlubName), 1)
              ]),
              _createElementVNode("span", _hoisted_182, [
                _createElementVNode("img", {
                  class: "editclubteams-drawer",
                  id: "editclubteams-drawer-klubber_logo",
                  src: _ctx.extractLogoURLFromClubLogoData(_ctx.lastEditMembersOfKlubLogo)
                }, null, 8, _hoisted_183)
              ])
            ]),
            _createVNode(_component_it_divider),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tempTournamentCategories, (tournamentcategory, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: tournamentcategory.id
              }, [
                (tournamentcategory.turneringskategori_status)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_184, [
                      _createElementVNode("div", _hoisted_185, [
                        _createElementVNode("div", _hoisted_186, [
                          _createElementVNode("span", _hoisted_187, [
                            _createElementVNode("span", _hoisted_188, [
                              _createElementVNode("table", _hoisted_189, [
                                _createElementVNode("thead", null, [
                                  _createElementVNode("tr", null, [
                                    _hoisted_190,
                                    _hoisted_191,
                                    _hoisted_192,
                                    _hoisted_193,
                                    _hoisted_194,
                                    (_ctx.showClubTeamMemberSelection)
                                      ? (_openBlock(), _createElementBlock("th", _hoisted_195, "Hold medlem"))
                                      : _createCommentVNode("", true),
                                    _hoisted_196
                                  ])
                                ]),
                                _createElementVNode("tr", null, [
                                  _createElementVNode("td", {
                                    id: 'editclubteams-drawer-table-row' + (index+1),
                                    hidden: ""
                                  }, _toDisplayString(tournamentcategory.id), 9, _hoisted_197),
                                  _createElementVNode("td", {
                                    id: 'editclubteams-drawer-table-row' + (index+1)
                                  }, _toDisplayString(tournamentcategory.turneringskategori_navn), 9, _hoisted_198),
                                  _createElementVNode("td", {
                                    id: 'editclubteams-drawer-table-row' + (index+1)
                                  }, _toDisplayString(this.getNumberOfTeamCompetitionRegistrationsInCategory(this.tempKlub.hold_id, tournamentcategory.id)), 9, _hoisted_199),
                                  _createElementVNode("td", {
                                    id: 'editclubteams-drawer-table-row' + (index+1)
                                  }, _toDisplayString(tournamentcategory.turneringskategori_pris), 9, _hoisted_200),
                                  (_ctx.showClubTeamMemberSelection && _ctx.klubTeamMemberShowSelectionForThisCategory[index])
                                    ? (_openBlock(), _createElementBlock("td", {
                                        key: 0,
                                        id: 'editclubteams-drawer-table-row' + (index+1)
                                      }, "1", 8, _hoisted_201))
                                    : (_openBlock(), _createElementBlock("td", {
                                        key: 1,
                                        id: 'editclubteams-drawer-table-row' + (index+1)
                                      }, [
                                        _createVNode(_component_va_select, {
                                          class: "editclubteams-drawer",
                                          modelValue: _ctx.klubTeamAddAmountValue[index],
                                          "onUpdate:modelValue": ($event: any) => ((_ctx.klubTeamAddAmountValue[index]) = $event),
                                          options: _ctx.klubTeamAddAmountOptions,
                                          "text-by": "name",
                                          "track-by": "id",
                                          label: "Antal",
                                          bordered: ""
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
                                      ], 8, _hoisted_202)),
                                  (_ctx.showClubTeamMemberSelection && _ctx.klubTeamMemberShowSelectionForThisCategory[index])
                                    ? (_openBlock(), _createElementBlock("td", {
                                        key: 2,
                                        id: 'editclubteams-drawer-table-row' + (index+1)
                                      }, [
                                        _createVNode(_component_va_select, {
                                          class: "editclubteams-drawer",
                                          modelValue: _ctx.klubTeamMemberNameValue[index],
                                          "onUpdate:modelValue": ($event: any) => ((_ctx.klubTeamMemberNameValue[index]) = $event),
                                          options: _ctx.klubTeamMemberNameOptions,
                                          "text-by": "name",
                                          "track-by": "id",
                                          label: "Medlem",
                                          width: "220px",
                                          searchable: "",
                                          bordered: ""
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
                                      ], 8, _hoisted_203))
                                    : (_ctx.showClubTeamMemberSelection)
                                      ? (_openBlock(), _createElementBlock("td", {
                                          key: 3,
                                          id: 'editclubteams-drawer-table-row' + (index+1)
                                        }, "-", 8, _hoisted_204))
                                      : _createCommentVNode("", true),
                                  _createElementVNode("td", {
                                    id: 'editclubteams-drawer-table-row' + (index+1)
                                  }, [
                                    _createVNode(_component_it_button_group, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_it_button, {
                                          class: "btn editclubteams-drawer",
                                          icon: "group_add",
                                          type: "primary",
                                          pulse: _ctx.currentTournamentSeasonId > 0,
                                          onClick: ($event: any) => (_ctx.addTeamToClub(tournamentcategory.id, index)),
                                          disabled: _ctx.currentTournamentSeasonId < 1,
                                          style: {"margin-right":"4px"}
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_206
                                          ]),
                                          _: 2
                                        }, 1032, ["pulse", "onClick", "disabled"]),
                                        _createVNode(_component_it_button, {
                                          class: "btn editclubteams-drawer",
                                          icon: "close",
                                          type: "primary",
                                          onClick: _cache[108] || (_cache[108] = ($event: any) => (_ctx.closeEditClubTeam())),
                                          style: {"margin-right":"4px"}
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_207
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ], 8, _hoisted_205)
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createVNode(_component_it_divider)
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_it_drawer, {
          modelValue: _ctx.addClubMembersDrawerVisible,
          "onUpdate:modelValue": _cache[116] || (_cache[116] = ($event: any) => ((_ctx.addClubMembersDrawerVisible) = $event)),
          width: "650px"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_208, [
              _createElementVNode("div", _hoisted_209, [
                _createElementVNode("h6", _hoisted_210, _toDisplayString(_ctx.lastEditMembersOfKlubName), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_211, [
              _createElementVNode("div", _hoisted_212, [
                _createVNode(_component_va_button, {
                  class: "btn",
                  rounded: false,
                  onClick: _cache[110] || (_cache[110] = ($event: any) => (_ctx.resetMemberSearch()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_va_icon, {
                      class: "reset",
                      name: "autorenew"
                    })
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_213, [
                _createVNode(_component_va_input, {
                  modelValue: _ctx.memberSearchInputValue,
                  "onUpdate:modelValue": _cache[111] || (_cache[111] = ($event: any) => ((_ctx.memberSearchInputValue) = $event)),
                  label: "Søg alle medlemmer",
                  onKeyup: _cache[112] || (_cache[112] = _withKeys(($event: any) => (_ctx.findMember()), ["enter"]))
                }, {
                  prependInner: _withCtx(() => [
                    _createVNode(_component_va_icon, { name: "travel_explore" })
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_va_button, {
                  size: "small",
                  class: "btn ml-2",
                  rounded: false,
                  onClick: _cache[113] || (_cache[113] = ($event: any) => (_ctx.findMember()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_va_icon, { name: "search" }),
                    _hoisted_214
                  ]),
                  _: 1
                })
              ])
            ]),
            _createVNode(_component_it_divider),
            _hoisted_215,
            _createVNode(_component_it_divider),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tempMedlems, (medlem) => {
              return (_openBlock(), _createElementBlock("div", {
                key: medlem.id,
                class: _normalizeClass({ managerpopout: _ctx.lastEditMembersOfKlubManagerMemberId === medlem.id})
              }, [
                _createElementVNode("div", _hoisted_216, [
                  _createElementVNode("div", _hoisted_217, [
                    _createVNode(_component_va_icon, {
                      class: "ml-1",
                      name: "person",
                      color: _ctx.lastEditMembersOfKlubManagerMemberId === medlem.id ? 'success' : 'primary'
                    }, null, 8, ["color"]),
                    _createElementVNode("p", {
                      class: _normalizeClass([{ manager: _ctx.lastEditMembersOfKlubManagerMemberId === medlem.id }, 'align-self--center'])
                    }, _toDisplayString(medlem?.user_id?.firstname + ' ' + medlem?.user_id?.lastname + ' [' + (medlem?.medlem_licens === null ? 'Ingen' : medlem?.medlem_licens) + ']'), 3)
                  ]),
                  ((medlem.klubber_id !== undefined && medlem.klubber_id !== null && (medlem.klubber_id.id === 22 || medlem.klubber_id.id === _ctx.lastEditMembersOfKlubId)))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_218, [
                        _createVNode(_component_va_chip, {
                          square: "",
                          color: medlem.klubber_id.id === _ctx.lastEditMembersOfKlubId ? 'success' : 'warning'
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(medlem.klubber_id.klubber_klubnavn), 1)
                          ]),
                          _: 2
                        }, 1032, ["color"])
                      ]))
                    : (medlem.klubber_id !== undefined && medlem.klubber_id !== null)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_219, [
                          _createVNode(_component_va_chip, {
                            square: "",
                            color: "primary"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(medlem.klubber_id.klubber_klubnavn), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]))
                      : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_220, [
                    _createVNode(_component_va_button, {
                      flat: "",
                      rounded: false,
                      onClick: ($event: any) => (_ctx.extraMemberInfo(medlem.id)),
                      icon: "help_outline"
                    }, null, 8, ["onClick"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_221, [
                  _createElementVNode("div", _hoisted_222, [
                    _createVNode(_component_va_button, {
                      size: "small",
                      rounded: false,
                      color: "info",
                      icon: "person_add",
                      onClick: ($event: any) => (_ctx.addMemberToClub(medlem.id)),
                      disabled: _ctx.isMemberOfCurrentClub((medlem.klubber_id !== null ? medlem?.klubber_id?.id : null))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_223
                      ]),
                      _: 2
                    }, 1032, ["onClick", "disabled"]),
                    _createVNode(_component_va_button, {
                      size: "small",
                      rounded: false,
                      class: "mr-2 ml-2",
                      icon: _ctx.lastEditMembersOfKlubManagerMemberId == medlem.id ? 'done': 'supervisor_account',
                      color: _ctx.lastEditMembersOfKlubManagerMemberId === medlem.id ? 'success': 'secondary',
                      disabled: !_ctx.isMemberOfCurrentClub((medlem.klubber_id !== null ? medlem?.klubber_id?.id : null)),
                      onClick: ($event: any) => (_ctx.setMemberClubManager(medlem.id, false, true))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.lastEditMembersOfKlubManagerMemberId == medlem.id ? 'Er klubansvarlig' : 'Gør ansvarlig'), 1)
                      ]),
                      _: 2
                    }, 1032, ["icon", "color", "disabled", "onClick"]),
                    _createVNode(_component_va_button, {
                      size: "small",
                      rounded: false,
                      color: "danger",
                      icon: "person_remove",
                      disabled: !_ctx.isMemberOfCurrentClub((medlem.klubber_id !== null ? medlem?.klubber_id?.id : null)),
                      onClick: ($event: any) => (_ctx.removeMemberFromClub(medlem.id))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_224
                      ]),
                      _: 2
                    }, 1032, ["disabled", "onClick"])
                  ])
                ]),
                _createVNode(_component_it_divider)
              ], 2))
            }), 128)),
            _createVNode(_component_va_modal, {
              modelValue: _ctx.extraMemberModal,
              "onUpdate:modelValue": _cache[115] || (_cache[115] = ($event: any) => ((_ctx.extraMemberModal) = $event)),
              "hide-default-actions": "",
              "overlay-opacity": "",
              size: "small",
              "z-index": "999"
            }, {
              footer: _withCtx(() => [
                _createVNode(_component_va_button, {
                  onClick: _cache[114] || (_cache[114] = ($event: any) => (_ctx.extraMemberModal = !_ctx.extraMemberModal))
                }, {
                  default: _withCtx(() => [
                    _hoisted_254
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _hoisted_225,
                _createElementVNode("div", _hoisted_226, [
                  _createElementVNode("div", _hoisted_227, [
                    _hoisted_228,
                    _createTextVNode(" " + _toDisplayString(_ctx.memberData.brugerFornavn + ' ' + _ctx.memberData.brugerEfternavn + ' (' + _ctx.calcAge(_ctx.memberData.medlemFoedselsdag) + ' år)'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_229, [
                    _hoisted_230,
                    _createTextVNode(" " + _toDisplayString((_ctx.memberData.medlemLicens === null ? 'Ingen licensnummer' : _ctx.memberData.medlemLicens)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_231, [
                    _createVNode(_component_va_chip, {
                      square: "",
                      color: _ctx.memberData.medlemStatus ? 'success': 'danger'
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString((_ctx.memberData.medlemStatus ? 'Har aktiv licens': 'Har ingen licens')), 1)
                      ]),
                      _: 1
                    }, 8, ["color"])
                  ]),
                  _createElementVNode("div", _hoisted_232, [
                    _hoisted_233,
                    _createTextVNode(" " + _toDisplayString(_ctx.memberData.paradartspillerCheck ? 'Ja' : 'Nej'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_234, [
                    _hoisted_235,
                    _createTextVNode(" " + _toDisplayString(_ctx.memberData.medlemKoen), 1)
                  ]),
                  _createElementVNode("div", _hoisted_236, [
                    _hoisted_237,
                    _createTextVNode(" " + _toDisplayString(new Date(_ctx.memberData.medlemFoedselsdag).toLocaleDateString('da-DK', { day: '2-digit', month: '2-digit', year: '2-digit' }).replaceAll('.', '/')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_238, [
                    _hoisted_239,
                    _createTextVNode(" " + _toDisplayString(new Date(_ctx.memberData.medlemBegyndelse).toLocaleDateString('da-DK', { day: '2-digit', month: '2-digit', year: '2-digit'}).replaceAll('.', '/')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_240, [
                    _hoisted_241,
                    _createTextVNode(" " + _toDisplayString(_ctx.memberData.medlemVejnummer), 1)
                  ]),
                  _createElementVNode("div", _hoisted_242, [
                    _hoisted_243,
                    _createTextVNode(" " + _toDisplayString(_ctx.memberData.medlemPostnummer + ', ' + _ctx.memberData.medlemBy), 1)
                  ]),
                  _createElementVNode("div", _hoisted_244, [
                    _hoisted_245,
                    _createTextVNode(" " + _toDisplayString(_ctx.memberData.brugerTelefon), 1)
                  ]),
                  _createElementVNode("div", _hoisted_246, [
                    _hoisted_247,
                    _createTextVNode(" " + _toDisplayString(_ctx.memberData.brugerEmail), 1)
                  ]),
                  _createElementVNode("div", _hoisted_248, [
                    _hoisted_249,
                    _createTextVNode(" " + _toDisplayString(_ctx.memberData.medlemKlubRolle), 1)
                  ]),
                  _createElementVNode("div", _hoisted_250, [
                    _hoisted_251,
                    _createElementVNode("span", null, _toDisplayString((_ctx.testActiveQuarantine(_ctx.memberData.medlemKarantaeneDato, _ctx.memberData.medlemKarantaeneSlutdato) ? ' Ja' : ' Nej' )), 1)
                  ]),
                  (_ctx.testActiveQuarantine(_ctx.memberData.medlemKarantaeneDato, _ctx.memberData.medlemKarantaeneSlutdato))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_252, [
                        _hoisted_253,
                        _createTextVNode(" " + _toDisplayString((new Date(_ctx.memberData.medlemKarantaeneDato).toLocaleDateString('da-DK', {day: '2-digit', month: '2-digit', year: '2-digit' }).replaceAll('.', '/')) + ' - ' + (new Date(_ctx.memberData.medlemKarantaeneSlutdato).toLocaleDateString('da-DK', {day: '2-digit', month: '2-digit', year: '2-digit' }).replaceAll('.', '/'))), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ], 512), [
        [_vShow, _ctx.tabValue === 'Vis og rediger klubber']
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_255, [
        _createElementVNode("div", _hoisted_256, [
          (_ctx.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_257, _toDisplayString(_ctx.error), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_258, [
                (!_ctx.submitted)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_259, [
                      _createElementVNode("div", _hoisted_260, [
                        _createVNode(_component_va_form, {
                          ref: "form",
                          id: "newclub-form",
                          onSubmit: _ctx.handleSubmit
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_261, [
                              _createElementVNode("div", _hoisted_262, [
                                _createElementVNode("div", _hoisted_263, [
                                  _createVNode(_component_va_input, {
                                    class: "mb-4",
                                    modelValue: _ctx.klubData.klubKlubnavn,
                                    "onUpdate:modelValue": _cache[117] || (_cache[117] = ($event: any) => ((_ctx.klubData.klubKlubnavn) = $event)),
                                    type: "text",
                                    label: "Klubnavn",
                                    rules: [(klubKlubnavn) => (_ctx.klubData.klubKlubnavn !== null && _ctx.klubData.klubKlubnavn?.length > 1) || 'Klubnavn mangler'],
                                    placeholder: "Navn",
                                    bordered: ""
                                  }, null, 8, ["modelValue", "rules"])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_264, [
                                _createElementVNode("div", _hoisted_265, [
                                  _createVNode(_component_QuillEditor, {
                                    ref: "clubDescription",
                                    options: _ctx.quillToolbar,
                                    contentType: "html",
                                    content: _ctx.klubData.klubBeskrivelse,
                                    "onUpdate:content": _cache[118] || (_cache[118] = ($event: any) => ((_ctx.klubData.klubBeskrivelse) = $event)),
                                    class: "quillAdmClubDescription"
                                  }, null, 8, ["options", "content"])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_266, [
                                _createElementVNode("div", _hoisted_267, [
                                  _createVNode(_component_va_input, {
                                    class: "mb-4",
                                    modelValue: _ctx.klubData.klubVejnavn,
                                    "onUpdate:modelValue": _cache[119] || (_cache[119] = ($event: any) => ((_ctx.klubData.klubVejnavn) = $event)),
                                    type: "text",
                                    label: "Adresse",
                                    rules: [(klubVejnavn) => (_ctx.klubData.klubVejnavn !== null && _ctx.klubData.klubVejnavn?.length > 1) || 'Der mangler en adresse'],
                                    placeholder: "Adresse",
                                    bordered: ""
                                  }, null, 8, ["modelValue", "rules"])
                                ]),
                                _createElementVNode("div", _hoisted_268, [
                                  _createVNode(_component_va_input, {
                                    class: "mb-4",
                                    modelValue: _ctx.klubData.klubPostnummer,
                                    "onUpdate:modelValue": _cache[120] || (_cache[120] = ($event: any) => ((_ctx.klubData.klubPostnummer) = $event)),
                                    onFocus: _cache[121] || (_cache[121] = ($event: any) => (_ctx.medlemByPostnummerInputFocus = 2)),
                                    type: "number",
                                    label: "Postnummer",
                                    rules: [(klubPostnummer) => (_ctx.klubData.klubPostnummer !== null && _ctx.klubData.klubPostnummer.length === 4) || 'Postnummer mangler'],
                                    placeholder: "Nr.",
                                    bordered: ""
                                  }, null, 8, ["modelValue", "rules"])
                                ]),
                                _createElementVNode("div", _hoisted_269, [
                                  _createVNode(_component_va_input, {
                                    class: "md-4",
                                    modelValue: _ctx.klubData.klubBy,
                                    "onUpdate:modelValue": _cache[122] || (_cache[122] = ($event: any) => ((_ctx.klubData.klubBy) = $event)),
                                    onFocus: _cache[123] || (_cache[123] = ($event: any) => (_ctx.medlemByPostnummerInputFocus = 1)),
                                    type: "text",
                                    label: "By",
                                    placeholder: "By",
                                    bordered: ""
                                  }, null, 8, ["modelValue"])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_270, [
                                _createElementVNode("div", _hoisted_271, [
                                  _createVNode(_component_va_input, {
                                    class: "mb-4",
                                    modelValue: _ctx.klubData.klubTelefonnummer,
                                    "onUpdate:modelValue": _cache[124] || (_cache[124] = ($event: any) => ((_ctx.klubData.klubTelefonnummer) = $event)),
                                    type: "number",
                                    label: "Telefonnummer",
                                    rules: [(klubTelefonnummer) => (_ctx.klubData.klubTelefonnummer !== null && _ctx.klubData.klubTelefonnummer.trim()?.length > 7) || 'Der mangler et telefonnummer'],
                                    placeholder: "Nr.",
                                    bordered: ""
                                  }, null, 8, ["modelValue", "rules"])
                                ]),
                                _createElementVNode("div", _hoisted_272, [
                                  _createVNode(_component_va_input, {
                                    class: "mb-4",
                                    modelValue: _ctx.klubData.klubEmail,
                                    "onUpdate:modelValue": _cache[125] || (_cache[125] = ($event: any) => ((_ctx.klubData.klubEmail) = $event)),
                                    type: "email",
                                    label: "Email",
                                    rules: [(klubEmail) => (_ctx.klubData.klubEmail !== null && _ctx.klubData.klubEmail?.length > 2 && _ctx.klubData.klubEmail.includes('@')) || 'Indtast venligst en korrekt email'],
                                    placeholder: "mailuser@domain.tld",
                                    bordered: ""
                                  }, null, 8, ["modelValue", "rules"])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_273, [
                                _createElementVNode("div", _hoisted_274, [
                                  _createVNode(_component_va_input, {
                                    class: "mb-4",
                                    modelValue: _ctx.klubData.klubHjemmeside,
                                    "onUpdate:modelValue": _cache[126] || (_cache[126] = ($event: any) => ((_ctx.klubData.klubHjemmeside) = $event)),
                                    type: "url",
                                    label: "Hjemmeside",
                                    placeholder: "Hjemmeside",
                                    bordered: "",
                                    rules: [(klubHjemmeside) => _ctx.klubData.klubHjemmeside === null || _ctx.klubData.klubHjemmeside?.length === 0 || _ctx.klubData.klubHjemmeside.includes('http://') || _ctx.klubData.klubHjemmeside.includes('https://') || 'Indtast en gyldig hjemmeside']
                                  }, null, 8, ["modelValue", "rules"])
                                ]),
                                _createElementVNode("div", _hoisted_275, [
                                  _createVNode(_component_va_input, {
                                    class: "mb-4",
                                    modelValue: _ctx.klubData.klubFacebook,
                                    "onUpdate:modelValue": _cache[127] || (_cache[127] = ($event: any) => ((_ctx.klubData.klubFacebook) = $event)),
                                    type: "url",
                                    label: "Facebook",
                                    placeholder: "Facebook",
                                    bordered: "",
                                    rules: [(klubFacebook) => _ctx.klubData.klubFacebook === null || _ctx.klubData.klubFacebook?.length === 0 || _ctx.klubData.klubFacebook.includes('https://da-dk.facebook.com/') || _ctx.klubData.klubFacebook.includes('https://www.facebook.com/') || _ctx.klubData.klubFacebook.includes('https://facebook.com/') || 'Indtast en gyldig Facebook adresse']
                                  }, null, 8, ["modelValue", "rules"])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_276, [
                                _createElementVNode("div", _hoisted_277, [
                                  _createVNode(_component_va_input, {
                                    class: "mb-4 center",
                                    modelValue: _ctx.klubData.klubHjemmekampe,
                                    "onUpdate:modelValue": _cache[128] || (_cache[128] = ($event: any) => ((_ctx.klubData.klubHjemmekampe) = $event)),
                                    type: "number",
                                    label: "Hjemmekampe",
                                    placeholder: "Antal",
                                    bordered: ""
                                  }, null, 8, ["modelValue"])
                                ]),
                                _createElementVNode("div", _hoisted_278, [
                                  _createVNode(_component_va_input, {
                                    class: "mb-4 center",
                                    modelValue: _ctx.klubData.klubBaner,
                                    "onUpdate:modelValue": _cache[129] || (_cache[129] = ($event: any) => ((_ctx.klubData.klubBaner) = $event)),
                                    type: "number",
                                    label: "Antal baner",
                                    placeholder: "Antal",
                                    bordered: ""
                                  }, null, 8, ["modelValue"])
                                ]),
                                _createElementVNode("div", _hoisted_279, [
                                  _createVNode(_component_va_input, {
                                    class: "mb-4 center",
                                    modelValue: _ctx.klubData.klubSaldo,
                                    "onUpdate:modelValue": _cache[130] || (_cache[130] = ($event: any) => ((_ctx.klubData.klubSaldo) = $event)),
                                    type: "number",
                                    label: "Saldo",
                                    placeholder: "Beløb",
                                    bordered: ""
                                  }, null, 8, ["modelValue"])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_280, [
                                _createElementVNode("div", _hoisted_281, [
                                  _createVNode(_component_va_checkbox, {
                                    class: "mb-4",
                                    modelValue: _ctx.klubData.klubKoerestolsvenlig,
                                    "onUpdate:modelValue": _cache[131] || (_cache[131] = ($event: any) => ((_ctx.klubData.klubKoerestolsvenlig) = $event)),
                                    label: "Kørestolsvenlig",
                                    bordered: ""
                                  }, null, 8, ["modelValue"])
                                ]),
                                _createElementVNode("div", _hoisted_282, [
                                  _createVNode(_component_va_select, {
                                    class: "mb-4",
                                    modelValue: _ctx.klubRegionTrackByValue,
                                    "onUpdate:modelValue": _cache[132] || (_cache[132] = ($event: any) => ((_ctx.klubRegionTrackByValue) = $event)),
                                    options: _ctx.klubRegionTrackByOptions,
                                    "text-by": "name",
                                    "track-by": "id",
                                    label: "Region",
                                    rules: [(klubRegionTrackByValue) => klubRegionTrackByValue.id != 0 || 'Husk at vælge region'],
                                    bordered: ""
                                  }, null, 8, ["modelValue", "options", "rules"])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_283, [
                                _createElementVNode("div", _hoisted_284, [
                                  _createVNode(_component_va_select, {
                                    class: "mb-4",
                                    label: "Tilføj klubansvarlig",
                                    id: "membersOfNewClub",
                                    options: _ctx.addManagerToClubOptions,
                                    modelValue: _ctx.addManagerToClubValue,
                                    "onUpdate:modelValue": _cache[133] || (_cache[133] = ($event: any) => ((_ctx.addManagerToClubValue) = $event)),
                                    "text-by": (addManagerToClubOptions) => addManagerToClubOptions.name,
                                    searchable: "",
                                    "track-by": (addManagerToClubOptions) => addManagerToClubOptions.id,
                                    onClick: _cache[134] || (_cache[134] = ($event: any) => (_ctx.clearInput())),
                                    onKeydown: _cache[135] || (_cache[135] = event => { _ctx.backSpace = event.key }),
                                    onKeypress: _cache[136] || (_cache[136] = e => { _ctx.memberSearchInputString += e.key })
                                  }, null, 8, ["options", "modelValue", "text-by", "track-by"])
                                ])
                              ])
                            ])
                          ]),
                          _: 1
                        }, 8, ["onSubmit"])
                      ]),
                      _createElementVNode("div", _hoisted_285, [
                        _createElementVNode("div", _hoisted_286, [
                          _createVNode(_component_va_button, {
                            class: "btn",
                            color: "success",
                            size: "large",
                            onClick: _cache[137] || (_cache[137] = ($event: any) => {_ctx.$refs.form.validate(); _ctx.createClub()})
                          }, {
                            default: _withCtx(() => [
                              _hoisted_287
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_288, [
                      _hoisted_289,
                      _createElementVNode("div", _hoisted_290, [
                        _createElementVNode("div", _hoisted_291, [
                          _createVNode(_component_va_button, {
                            class: "btn",
                            color: "success",
                            size: "large",
                            onClick: _cache[138] || (_cache[138] = ($event: any) => (_ctx.newCreateClub()))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_292
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]))
              ])),
          _createVNode(_component_it_drawer, {
            modelValue: _ctx.addOpeningHoursDrawerVisible,
            "onUpdate:modelValue": _cache[145] || (_cache[145] = ($event: any) => ((_ctx.addOpeningHoursDrawerVisible) = $event)),
            width: "650px"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_293, [
                _hoisted_294,
                _createVNode(_component_it_divider),
                _createElementVNode("div", _hoisted_295, [
                  _createElementVNode("div", _hoisted_296, [
                    _createElementVNode("div", _hoisted_297, [
                      _createElementVNode("div", _hoisted_298, [
                        _createVNode(_component_va_select, {
                          modelValue: _ctx.openingHoursDayValue,
                          "onUpdate:modelValue": _cache[139] || (_cache[139] = ($event: any) => ((_ctx.openingHoursDayValue) = $event)),
                          label: "Dag",
                          options: _ctx.openingHoursDayOptions,
                          bordered: ""
                        }, null, 8, ["modelValue", "options"])
                      ]),
                      _createElementVNode("div", _hoisted_299, [
                        _createVNode(_component_va_input, {
                          type: "time",
                          label: "Fra",
                          modelValue: _ctx.openingData.open,
                          "onUpdate:modelValue": _cache[140] || (_cache[140] = ($event: any) => ((_ctx.openingData.open) = $event)),
                          bordered: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_300, [
                        _createVNode(_component_va_input, {
                          type: "time",
                          label: "Til",
                          modelValue: _ctx.openingData.close,
                          "onUpdate:modelValue": _cache[141] || (_cache[141] = ($event: any) => ((_ctx.openingData.close) = $event)),
                          bordered: ""
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_301, [
                      _createElementVNode("div", _hoisted_302, [
                        _createVNode(_component_va_input, {
                          label: "Evt. kommentar",
                          type: "text",
                          modelValue: _ctx.openingData.comment,
                          "onUpdate:modelValue": _cache[142] || (_cache[142] = ($event: any) => ((_ctx.openingData.comment) = $event)),
                          bordered: ""
                        }, null, 8, ["modelValue"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_303, [
                    _createVNode(_component_va_button, {
                      size: "small",
                      color: "success",
                      onClick: _cache[143] || (_cache[143] = ($event: any) => (_ctx.addToOpeningHoursArray()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_304
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createVNode(_component_it_divider),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.openingHoursArray, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.id,
                    class: "row align--center openinghourscontainer"
                  }, [
                    _createElementVNode("div", _hoisted_305, [
                      _createElementVNode("div", _hoisted_306, [
                        _createElementVNode("div", _hoisted_307, [
                          _createElementVNode("p", null, _toDisplayString(item.day), 1)
                        ]),
                        _createElementVNode("div", _hoisted_308, [
                          _createElementVNode("p", null, "Fra: " + _toDisplayString(item.open), 1)
                        ]),
                        _createElementVNode("div", _hoisted_309, [
                          _createElementVNode("p", null, "Til: " + _toDisplayString(item.close), 1)
                        ])
                      ]),
                      (item.comment !== '')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_310, [
                            _createElementVNode("div", _hoisted_311, [
                              _createElementVNode("p", _hoisted_312, _toDisplayString(item.comment), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_313, [
                      _createElementVNode("button", {
                        class: "openinghoursbutton",
                        onClick: ($event: any) => (_ctx.removeOpeningHours(index))
                      }, [
                        _createVNode(_component_va_icon, {
                          name: "clear",
                          color: "danger"
                        })
                      ], 8, _hoisted_314)
                    ])
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_315, [
                _createElementVNode("div", _hoisted_316, [
                  _createVNode(_component_va_button, {
                    onClick: _cache[144] || (_cache[144] = ($event: any) => (this.addOpeningHoursDrawerVisible = false)),
                    color: "success"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_317
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ], 512), [
        [_vShow, _ctx.tabValue === 'Opret ny klub']
      ])
    ])
  ]))
}